/** Lao text for rates & availability: matrix, base rates, rate plans, packages and services. */
export const laoHotelRates: Record<string, string> = {
  // Navigation and page headings
  'Rates & availability': 'ລາຄາ ແລະ ຫ້ອງຫວ່າງ',
  'Availability matrix': 'ຕາຕະລາງຫ້ອງຫວ່າງ',
  'Base rates': 'ລາຄາພື້ນຖານ',
  'Rate plans & packages': 'ແຜນລາຄາ ແລະ ແພັກເກດ',
  'Services & extras': 'ບໍລິການ ແລະ ລາຍການເສີມ',
  'Rooms left, prices and restrictions for every rate plan, day by day.':
    'ຫ້ອງຫວ່າງ, ລາຄາ ແລະ ຂໍ້ກຳນົດຂອງທຸກແຜນລາຄາ ແຕ່ລະມື້',
  'The starting price of each room type, by weekday and season.':
    'ລາຄາເລີ່ມຕົ້ນຂອງແຕ່ລະປະເພດຫ້ອງ ຕາມວັນໃນອາທິດ ແລະ ລະດູການ',
  'Sell each room type in different ways, with or without extras.':
    'ຂາຍແຕ່ລະປະເພດຫ້ອງໄດ້ຫຼາຍແບບ ມີ ຫຼື ບໍ່ມີລາຍການເສີມ',
  'Breakfast, transfers, spa and everything else guests can add.':
    'ອາຫານເຊົ້າ, ລົດຮັບສົ່ງ, ສະປາ ແລະ ທຸກຢ່າງທີ່ແຂກສັ່ງເພີ່ມໄດ້',

  // Shared words
  N: 'ຄ',
  changes: 'ການປ່ຽນແປງ',
  plans: 'ແຜນ',
  package: 'ແພັກເກດ',
  packages: 'ແພັກເກດ',
  Package: 'ແພັກເກດ',
  Packages: 'ແພັກເກດ',
  Season: 'ລະດູການ',
  Seasons: 'ລະດູການ',
  Tonight: 'ຄືນນີ້',
  Base: 'ພື້ນຖານ',
  'per night': 'ຕໍ່ຄືນ',
  'Up to': 'ສູງສຸດ',
  'Fixed price': 'ລາຄາຄົງທີ່',
  Services: 'ບໍລິການ',
  Mixed: 'ຫຼາຍຄ່າ',
  On: 'ເປີດ',
  Off: 'ປິດ',
  All: 'ທັງໝົດ',
  In: 'ຢູ່ໃນ',
  Booked: 'ຈອງແລ້ວ',
  Occupancy: 'ອັດຕາການເຂົ້າພັກ',
  Dates: 'ວັນທີ',
  Restrictions: 'ຂໍ້ກຳນົດ',
  Conditions: 'ເງື່ອນໄຂ',
  Duplicate: 'ສຳເນົາ',
  Activate: 'ເປີດໃຊ້',
  Deactivate: 'ປິດໃຊ້',
  Surcharge: 'ເກັບເພີ່ມ',
  Fewer: 'ໜ້ອຍລົງ',
  More: 'ເພີ່ມ',
  Charged: 'ຄິດເງິນ',

  // Availability matrix
  'Days shown': 'ຈຳນວນມື້ທີ່ສະແດງ',
  'Matrix start date': 'ວັນທີເລີ່ມຕາຕະລາງ',
  'Show inactive plans': 'ສະແດງແຜນທີ່ບໍ່ໃຊ້ງານ',
  'Bulk update': 'ອັບເດດຫຼາຍລາຍການ',
  'Room types & rate plans': 'ປະເພດຫ້ອງ ແລະ ແຜນລາຄາ',
  'Add rooms to see availability': 'ເພີ່ມຫ້ອງເພື່ອເບິ່ງຫ້ອງຫວ່າງ',
  'Room types come from your rooms in Hotel settings.':
    'ປະເພດຫ້ອງມາຈາກຫ້ອງຂອງທ່ານໃນການຕັ້ງຄ່າໂຮງແຮມ',
  'No rate plans for this room type.': 'ປະເພດຫ້ອງນີ້ຍັງບໍ່ມີແຜນລາຄາ.',
  'Create a rate plan': 'ສ້າງແຜນລາຄາ',
  'Date price': 'ລາຄາຕາມວັນທີ',
  'Click a price to edit it. Drag across dates or Shift-click to select a range.':
    'ກົດລາຄາເພື່ອແກ້ໄຂ. ລາກຜ່ານຫຼາຍວັນ ຫຼື ກົດ Shift ເພື່ອເລືອກຊ່ວງວັນທີ',
  'Selected dates': 'ວັນທີທີ່ເລືອກ',
  'Stop sell applied': 'ຢຸດຂາຍແລ້ວ',
  'Dates opened for sale': 'ເປີດຂາຍວັນທີເຫຼົ່ານີ້ແລ້ວ',
  'Open for sale': 'ເປີດຂາຍ',
  'Arrivals closed': 'ປິດຮັບເຂົ້າພັກແລ້ວ',
  'Close arrivals': 'ປິດຮັບເຂົ້າພັກ',
  'Clear selection': 'ລ້າງການເລືອກ',
  'Whole room type': 'ທັງປະເພດຫ້ອງ',
  'All rates, standard included': 'ທຸກລາຄາ ລວມທັງລາຄາມາດຕະຖານ',
  'Room type stop sell': 'ຢຸດຂາຍທັງປະເພດຫ້ອງ',

  // Rate change form
  'Rates updated': 'ອັບເດດລາຄາແລ້ວ',
  'Dated overrides removed': 'ລຶບລາຄາ ແລະ ຂໍ້ກຳນົດຕາມວັນທີແລ້ວ',
  'Update several rate plans at once. Untouched fields keep their current values.':
    'ອັບເດດຫຼາຍແຜນລາຄາພ້ອມກັນ. ຊ່ອງທີ່ບໍ່ໄດ້ແກ້ໄຂຈະຮັກສາຄ່າເດີມ',
  'Days of the week': 'ວັນໃນອາທິດ',
  'All days': 'ທຸກມື້',
  Weeknights: 'ຄືນວັນທຳມະດາ',
  'Weekend nights': 'ຄືນທ້າຍອາທິດ',
  'Rate plans': 'ແຜນລາຄາ',
  'Apply to more plans': 'ໃຊ້ກັບແຜນອື່ນນຳ',
  'No rate plans yet': 'ຍັງບໍ່ມີແຜນລາຄາ',
  'Nightly price': 'ລາຄາຕໍ່ຄືນ',
  'Use plan price': 'ໃຊ້ລາຄາຂອງແຜນ',
  'Plan price': 'ລາຄາຂອງແຜນ',
  'Each date returns to the plan price (base rate, season and adjustment).':
    'ແຕ່ລະວັນກັບໄປໃຊ້ລາຄາຂອງແຜນ (ລາຄາພື້ນຖານ, ລະດູການ ແລະ ການປັບລາຄາ)',
  'Prices differ across these dates. Enter one price to apply to all.':
    'ລາຄາແຕ່ລະວັນບໍ່ເທົ່າກັນ. ໃສ່ລາຄາດຽວເພື່ອໃຊ້ກັບທຸກວັນ',
  'Checked on the arrival date.': 'ກວດສອບຕາມວັນເຂົ້າພັກ',
  'No new bookings for these nights.': 'ບໍ່ຮັບການຈອງໃໝ່ສຳລັບຄືນເຫຼົ່ານີ້',
  'Guests cannot check in on these dates.': 'ແຂກບໍ່ສາມາດເຊັກອິນໃນວັນທີເຫຼົ່ານີ້',
  'Guests cannot check out on these dates.': 'ແຂກບໍ່ສາມາດເຊັກເອົາໃນວັນທີເຫຼົ່ານີ້',
  'Change a price or restriction to continue.': 'ປ່ຽນລາຄາ ຫຼື ຂໍ້ກຳນົດເພື່ອດຳເນີນການຕໍ່',
  'Remove overrides': 'ລຶບການກຳນົດຕາມວັນທີ',
  'Apply changes': 'ນຳໃຊ້ການປ່ຽນແປງ',
  'Whole room types': 'ທັງປະເພດຫ້ອງ',
  'Restrictions on a whole room type apply to every rate, the standard rate sold online included.':
    'ຂໍ້ກຳນົດຂອງທັງປະເພດຫ້ອງໃຊ້ກັບທຸກລາຄາ ລວມທັງລາຄາມາດຕະຖານທີ່ຂາຍອອນລາຍ',
  'Use this to close a room type online: plan restrictions cannot close the standard rate.':
    'ໃຊ້ອັນນີ້ເພື່ອປິດຂາຍປະເພດຫ້ອງອອນລາຍ: ຂໍ້ກຳນົດຂອງແຜນລາຄາບໍ່ສາມາດປິດລາຄາມາດຕະຖານໄດ້',
  'Length of stay': 'ຈຳນວນຄືນທີ່ພັກ',
  'Checked on the arrival date. Leave empty to keep each rate’s own limit.':
    'ກວດສອບຕາມວັນເຂົ້າພັກ. ປ່ອຍຫວ່າງໄວ້ເພື່ອໃຊ້ຂໍ້ກຳນົດຂອງແຕ່ລະລາຄາ',
  'Each rate': 'ຕາມແຕ່ລະລາຄາ',
  'Remove restrictions': 'ລຶບຂໍ້ກຳນົດ',
  'Room type restrictions updated': 'ອັບເດດຂໍ້ກຳນົດປະເພດຫ້ອງແລ້ວ',
  'Room type restrictions removed': 'ລຶບຂໍ້ກຳນົດປະເພດຫ້ອງແລ້ວ',
  'Maximum stay must be at least the minimum stay': 'ຈຳນວນຄືນສູງສຸດຕ້ອງບໍ່ໜ້ອຍກວ່າຈຳນວນຄືນຕ່ຳສຸດ',

  // Base rates
  'base rates set': 'ກຳນົດລາຄາພື້ນຖານແລ້ວ',
  'current & upcoming seasons': 'ລະດູການປັດຈຸບັນ ແລະ ທີ່ຈະມາເຖິງ',
  'Base rates are the starting price of each room type. Rate plans that follow the base rate update automatically.':
    'ລາຄາພື້ນຖານແມ່ນລາຄາເລີ່ມຕົ້ນຂອງແຕ່ລະປະເພດຫ້ອງ. ແຜນລາຄາທີ່ອີງໃສ່ລາຄາພື້ນຖານຈະອັບເດດອັດຕະໂນມັດ',
  'Add rooms to set base rates': 'ເພີ່ມຫ້ອງເພື່ອກຳນົດລາຄາພື້ນຖານ',
  'Standard base rate': 'ລາຄາພື້ນຖານມາດຕະຖານ',
  'From room rates': 'ຈາກລາຄາຫ້ອງ',
  'Edit base rate': 'ແກ້ໄຂລາຄາພື້ນຖານ',
  'Set base rate': 'ກຳນົດລາຄາພື້ນຖານ',
  'Price by day of the week': 'ລາຄາຕາມວັນໃນອາທິດ',
  'Next 14 nights': '14 ຄືນຕໍ່ໄປ',
  'Add season': 'ເພີ່ມລະດູການ',
  'varies by day': 'ແຕກຕ່າງຕາມມື້',
  'Edit season': 'ແກ້ໄຂລະດູການ',
  'Delete season': 'ລຶບລະດູການ',
  'Delete season?': 'ລຶບລະດູການນີ້ບໍ?',
  'Season deleted': 'ລຶບລະດູການແລ້ວ',
  'No seasons. Add one for holidays, festivals or high season.':
    'ຍັງບໍ່ມີລະດູການ. ເພີ່ມສຳລັບວັນພັກ, ບຸນ ຫຼື ລະດູທ່ອງທ່ຽວ',
  'rate plan follows': 'ແຜນລາຄາອີງໃສ່',
  'rate plans follow': 'ແຜນລາຄາອີງໃສ່',
  'this base rate': 'ລາຄາພື້ນຖານນີ້',
  'No rate plans follow this base rate yet.': 'ຍັງບໍ່ມີແຜນລາຄາທີ່ອີງໃສ່ລາຄາພື້ນຖານນີ້',
  'Quick set': 'ຕັ້ງໄວ',
  'Weekend nights +15%': 'ຄືນທ້າຍອາທິດ +15%',
  'Weekend nights +25%': 'ຄືນທ້າຍອາທິດ +25%',
  'Weeknights −10%': 'ຄືນວັນທຳມະດາ −10%',
  'Same every day': 'ລາຄາດຽວທຸກມື້',
  'Leave a day empty to use the main price. Friday and Saturday are weekend nights.':
    'ປ່ອຍວ່າງເພື່ອໃຊ້ລາຄາຫຼັກ. ຄືນວັນສຸກ ແລະ ວັນເສົາແມ່ນຄືນທ້າຍອາທິດ',
  'Base rate saved': 'ບັນທຶກລາຄາພື້ນຖານແລ້ວ',
  'Standard rate per night (LAK)': 'ລາຄາມາດຕະຖານຕໍ່ຄືນ (ກີບ)',
  'Used every night unless a weekday price or season applies.':
    'ໃຊ້ທຸກຄືນ ເວັ້ນເສຍແຕ່ມີລາຄາຕາມວັນ ຫຼື ລະດູການ',
  'Vary price by day of the week': 'ລາຄາແຕກຕ່າງຕາມວັນໃນອາທິດ',
  'Charge more on busy nights, less on quiet ones.': 'ເກັບແພງຂຶ້ນໃນຄືນທີ່ຄົນຫຼາຍ ຖືກລົງໃນຄືນທີ່ງຽບ',
  'Save base rate': 'ບັນທຶກລາຄາພື້ນຖານ',
  'New season': 'ລະດູການໃໝ່',
  'A season replaces the base rate of one room type for a date range.':
    'ລະດູການໃຊ້ແທນລາຄາພື້ນຖານຂອງປະເພດຫ້ອງໜຶ່ງໃນຊ່ວງວັນທີທີ່ກຳນົດ',
  'Season saved': 'ບັນທຶກລະດູການແລ້ວ',
  'Season name': 'ຊື່ລະດູການ',
  'e.g. Lao New Year, High season': 'ເຊັ່ນ: ບຸນປີໃໝ່ລາວ, ລະດູທ່ອງທ່ຽວ',
  'First night': 'ຄືນທຳອິດ',
  'Last night': 'ຄືນສຸດທ້າຍ',
  'Season rate per night (LAK)': 'ລາຄາລະດູການຕໍ່ຄືນ (ກີບ)',
  'vs. standard base rate': 'ທຽບກັບລາຄາພື້ນຖານມາດຕະຖານ',
  'For example, a higher price on festival weekend nights.':
    'ຕົວຢ່າງ: ລາຄາສູງຂຶ້ນໃນຄືນທ້າຍອາທິດຊ່ວງບຸນ',
  'Seasons of the same room type cannot overlap.': 'ລະດູການຂອງປະເພດຫ້ອງດຽວກັນບໍ່ສາມາດຊ້ອນກັນ',
  'Save season': 'ບັນທຶກລະດູການ',
  'The season must end on or after its first date': 'ລະດູການຕ້ອງສິ້ນສຸດໃນ ຫຼື ຫຼັງວັນທຳອິດ',
  'A season can cover up to one year': 'ລະດູການໜຶ່ງຍາວໄດ້ສູງສຸດໜຶ່ງປີ',
  'Season not found in this workspace': 'ບໍ່ພົບລະດູການນີ້',
  'This property has reached its 500 season limit': 'ໂຮງແຮມນີ້ມີລະດູການຄົບ 500 ລາຍການແລ້ວ',
  'Choose a color': 'ເລືອກສີ',

  // Rate plans & packages
  'All plans': 'ທຸກແຜນ',
  Standard: 'ທົ່ວໄປ',
  'Plan type': 'ປະເພດແຜນ',
  'New package': 'ແພັກເກດໃໝ່',
  'Edit package': 'ແກ້ໄຂແພັກເກດ',
  'Create package': 'ສ້າງແພັກເກດ',
  'Create rate plan': 'ສ້າງແຜນລາຄາ',
  'Rate plan created': 'ສ້າງແຜນລາຄາແລ້ວ',
  'Rate plan activated': 'ເປີດໃຊ້ແຜນລາຄາແລ້ວ',
  'Rate plan deactivated': 'ປິດໃຊ້ແຜນລາຄາແລ້ວ',
  'Search rate plans': 'ຄົ້ນຫາແຜນລາຄາ',
  'Build your first rate plan': 'ສ້າງແຜນລາຄາທຳອິດ',
  'Sell the same room in different ways: flexible, non-refundable, long stay or with breakfast.':
    'ຂາຍຫ້ອງດຽວກັນໄດ້ຫຼາຍແບບ: ຍົກເລີກໄດ້, ບໍ່ຄືນເງິນ, ພັກດົນ ຫຼື ລວມອາຫານເຊົ້າ',
  'Any length of stay': 'ພັກໄດ້ທຸກໄລຍະ',
  'Bundle the room with services such as breakfast or an airport transfer.':
    'ລວມຫ້ອງພັກກັບບໍລິການ ເຊັ່ນ ອາຫານເຊົ້າ ຫຼື ລົດຮັບສົ່ງສະໜາມບິນ',
  'Sell the same room type with its own price and conditions.':
    'ຂາຍປະເພດຫ້ອງດຽວກັນດ້ວຍລາຄາ ແລະ ເງື່ອນໄຂຂອງຕົນເອງ',
  'Room only, with its own price and rules.': 'ຫ້ອງພັກຢ່າງດຽວ ມີລາຄາ ແລະ ກົດຂອງຕົນເອງ',
  'Room plus included services.': 'ຫ້ອງພັກພ້ອມບໍລິການທີ່ລວມ',
  'e.g. Bed & breakfast': 'ເຊັ່ນ: ຫ້ອງພັກ ແລະ ອາຫານເຊົ້າ',
  'e.g. Non-refundable': 'ເຊັ່ນ: ບໍ່ຄືນເງິນ',
  'Shown to staff when they choose a plan.': 'ສະແດງໃຫ້ພະນັກງານເຫັນເວລາເລືອກແຜນ',
  'Follow base rate': 'ອີງໃສ່ລາຄາພື້ນຖານ',
  'Prices move with the base rate, weekday prices and seasons of this room type.':
    'ລາຄາປ່ຽນຕາມລາຄາພື້ນຖານ, ລາຄາຕາມວັນ ແລະ ລະດູການຂອງປະເພດຫ້ອງນີ້',
  'Adjustment type': 'ປະເພດການປັບລາຄາ',
  'Price per night (LAK)': 'ລາຄາຕໍ່ຄືນ (ກີບ)',
  'Included services': 'ບໍລິການທີ່ລວມ',
  'Manage services': 'ຈັດການບໍລິການ',
  'No services yet.': 'ຍັງບໍ່ມີບໍລິການ.',
  'Add breakfast, transfers or spa treatments': 'ເພີ່ມອາຫານເຊົ້າ, ລົດຮັບສົ່ງ ຫຼື ສະປາ',
  'Included value': 'ມູນຄ່າທີ່ລວມ',
  'Use as surcharge': 'ໃຊ້ເປັນຄ່າເກັບເພີ່ມ',
  'Inactive plans stay on existing reservations.': 'ແຜນທີ່ປິດໃຊ້ຍັງຄົງຢູ່ໃນການຈອງເກົ່າ',
  'Untitled plan': 'ແຜນທີ່ຍັງບໍ່ມີຊື່',
  'Change prices for specific dates in the availability matrix.':
    'ປ່ຽນລາຄາສະເພາະວັນທີໃນຕາຕະລາງຫ້ອງຫວ່າງ',
  'Choose active services for this package': 'ເລືອກບໍລິການທີ່ເປີດໃຊ້ສຳລັບແພັກເກດນີ້',
  'Include each service once': 'ໃສ່ແຕ່ລະບໍລິການພຽງເທື່ອດຽວ',
  'Enter a percentage between -100% and 500%': 'ໃສ່ເປີເຊັນລະຫວ່າງ -100% ຫາ 500%',
  'Choose up to 366 dates': 'ເລືອກໄດ້ສູງສຸດ 366 ວັນ',
  'Choose at least one change': 'ເລືອກການປ່ຽນແປງຢ່າງໜ້ອຍໜຶ່ງລາຍການ',
  'Choose each rate plan once': 'ເລືອກແຕ່ລະແຜນລາຄາພຽງເທື່ອດຽວ',
  'No dates in this range fall on the chosen weekdays': 'ບໍ່ມີວັນທີໃນຊ່ວງນີ້ທີ່ກົງກັບວັນທີ່ເລືອກ',

  // Services
  'active services': 'ບໍລິການທີ່ເປີດໃຊ້',
  'packages with services': 'ແພັກເກດທີ່ມີບໍລິການ',
  'Sell extras at the front desk and include them in packages. Prices post to the guest folio.':
    'ຂາຍລາຍການເສີມທີ່ເຄົາເຕີ ແລະ ລວມໃນແພັກເກດ. ລາຄາຖືກບັນທຶກເຂົ້າບັນຊີແຂກ',
  'Search services': 'ຄົ້ນຫາບໍລິການ',
  'New service': 'ບໍລິການໃໝ່',
  'Edit service': 'ແກ້ໄຂບໍລິການ',
  'Save service': 'ບັນທຶກບໍລິການ',
  'Create service': 'ສ້າງບໍລິການ',
  'Service saved': 'ບັນທຶກບໍລິການແລ້ວ',
  'Service created': 'ສ້າງບໍລິການແລ້ວ',
  'Service archived': 'ຢຸດໃຊ້ບໍລິການແລ້ວ',
  'Service restored': 'ກູ້ຄືນບໍລິການແລ້ວ',
  'Suggested services added': 'ເພີ່ມບໍລິການແນະນຳແລ້ວ',
  'Start with popular hotel services': 'ເລີ່ມດ້ວຍບໍລິການໂຮງແຮມທີ່ນິຍົມ',
  'Add breakfast, airport transfers, massage and more in one click. You can change every price afterwards.':
    'ເພີ່ມອາຫານເຊົ້າ, ລົດຮັບສົ່ງສະໜາມບິນ, ນວດ ແລະ ອື່ນໆ ໃນຄລິກດຽວ. ປ່ຽນລາຄາໄດ້ພາຍຫຼັງ',
  'Add suggested services': 'ເພີ່ມບໍລິການແນະນຳ',
  'Create my own': 'ສ້າງເອງ',
  'No archived services': 'ບໍ່ມີບໍລິການທີ່ຢຸດໃຊ້',
  'No services match these filters': 'ບໍ່ມີບໍລິການທີ່ກົງກັບຕົວກອງ',
  'Sold separately': 'ຂາຍແຍກ',
  'Services can be posted to a guest folio and included in packages.':
    'ບໍລິການສາມາດບັນທຶກເຂົ້າບັນຊີແຂກ ແລະ ລວມໃນແພັກເກດໄດ້',
  'Service name': 'ຊື່ບໍລິການ',
  'e.g. Breakfast buffet': 'ເຊັ່ນ: ອາຫານເຊົ້າບຸບເຟ່',
  'Price (LAK)': 'ລາຄາ (ກີບ)',
  'Enter 0 for a free service.': 'ໃສ່ 0 ສຳລັບບໍລິການຟຣີ',
  'What is included, times, conditions': 'ມີຫຍັງແດ່, ເວລາ, ເງື່ອນໄຂ',
  'Example: 2 guests, 3 nights': 'ຕົວຢ່າງ: 2 ຄົນ, 3 ຄືນ',
  'Available to sell': 'ເປີດຂາຍ',
  'Archived services stay on existing folios and packages.':
    'ບໍລິການທີ່ຢຸດໃຊ້ຍັງຄົງຢູ່ໃນບັນຊີແຂກ ແລະ ແພັກເກດເກົ່າ',
  'Service not found in this workspace': 'ບໍ່ພົບບໍລິການນີ້',
  'Service name already exists': 'ມີຊື່ບໍລິການນີ້ແລ້ວ',
  'This property has reached its 300 service limit': 'ໂຮງແຮມນີ້ມີບໍລິການຄົບ 300 ລາຍການແລ້ວ',
  'Food & beverage': 'ອາຫານ ແລະ ເຄື່ອງດື່ມ',
  Transport: 'ການເດີນທາງ',
  'Spa & wellness': 'ສະປາ ແລະ ສຸຂະພາບ',
  'Tours & activities': 'ທ່ອງທ່ຽວ ແລະ ກິດຈະກຳ',
  'Room extras': 'ລາຍການເສີມໃນຫ້ອງ',
  'Other services': 'ບໍລິການອື່ນໆ',
  'Per item': 'ຕໍ່ລາຍການ',
  'per item': 'ຕໍ່ລາຍການ',
  'Per night': 'ຕໍ່ຄືນ',
  'Per guest': 'ຕໍ່ຄົນ',
  'per guest': 'ຕໍ່ຄົນ',
  'Per guest per night': 'ຕໍ່ຄົນຕໍ່ຄືນ',
  'per guest per night': 'ຕໍ່ຄົນຕໍ່ຄືນ',
  'Per stay': 'ຕໍ່ການພັກ',
  'per stay': 'ຕໍ່ການພັກ',
  'Airport pickup, laundry bag': 'ຮັບສະໜາມບິນ, ຖົງຊັກເຄື່ອງ',
  'Extra bed, parking': 'ຕຽງເສີມ, ບ່ອນຈອດລົດ',
  'Massage, city tour': 'ນວດ, ທ່ຽວໃນເມືອງ',
  'Breakfast, dinner': 'ອາຫານເຊົ້າ, ອາຫານແລງ',
  'Late checkout, welcome set': 'ເຊັກເອົາຊ້າ, ຊຸດຕ້ອນຮັບ',
  'Breakfast buffet': 'ອາຫານເຊົ້າບຸບເຟ່',
  'Airport transfer': 'ລົດຮັບສົ່ງສະໜາມບິນ',
  'Traditional Lao massage (60 min)': 'ນວດແຜນລາວ (60 ນາທີ)',
  'Mekong sunset cruise': 'ລ່ອງເຮືອຊົມຕາເວັນຕົກແມ່ນ້ຳຂອງ',
  'Late checkout until 16:00': 'ເຊັກເອົາຊ້າເຖິງ 16:00',
  'Extra bed': 'ຕຽງເສີມ',
  'Laundry bag': 'ຖົງຊັກເຄື່ອງ',
};
